import _defineProperty from "/codebuild/output/src2417502137/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from "react";
import ReactIdSwiper from "react-id-swiper";
import Image from "./CustomImage";
import { getImageUrl } from "../services/image";
import dynamic from "next/dynamic";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var CardPlace = dynamic(function () {
  return import("./CardPlace");
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("./CardPlace")];
    },
    modules: ["../components/Swiper.js -> " + "./CardPlace"]
  }
});
var CardRestaurant = dynamic(function () {
  return import("./CardRestaurant");
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("./CardRestaurant")];
    },
    modules: ["../components/Swiper.js -> " + "./CardRestaurant"]
  }
});
var CardRoom = dynamic(function () {
  return import("./CardRoom");
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("./CardRoom")];
    },
    modules: ["../components/Swiper.js -> " + "./CardRoom"]
  }
});
var CardPoster = dynamic(function () {
  return import("./CardPoster");
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("./CardPoster")];
    },
    modules: ["../components/Swiper.js -> " + "./CardPoster"]
  }
});
var CardProperty = dynamic(function () {
  return import("./CardProperty");
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("./CardProperty")];
    },
    modules: ["../components/Swiper.js -> " + "./CardProperty"]
  }
});

var Swiper = function Swiper(props) {
  var breakpoints = [];

  if (props.sm) {
    breakpoints[565] = {
      slidesPerView: props.sm
    };
  }

  if (props.md) {
    breakpoints[768] = {
      slidesPerView: props.md
    };
  }

  if (props.lg) {
    breakpoints[991] = {
      slidesPerView: props.lg
    };
  }

  if (props.xl) {
    breakpoints[1200] = {
      slidesPerView: props.xl
    };
  }

  if (props.xxl) {
    breakpoints[1400] = {
      slidesPerView: props.xxl
    };
  }

  if (props.xxxl) {
    breakpoints[1600] = {
      slidesPerView: props.xxxl
    };
  }

  var params = {
    containerClass: "swiper-container ".concat(props.className),
    slidesPerView: props.perView,
    effect: props.effect,
    allowTouchMove: props.allowTouchMove === false ? false : true,
    spaceBetween: props.spaceBetween,
    centeredSlides: props.centeredSlides,
    roundLengths: props.roundLengths,
    loop: props.loop,
    speed: props.speed ? props.speed : 400,
    parallax: props.parallax,
    breakpoints: breakpoints,
    autoplay: props.autoplay ? {
      delay: props.delay
    } : false,
    pagination: props.pagination !== false ? {
      el: ".swiper-pagination.".concat(props.paginationClass),
      clickable: true,
      dynamicBullets: true
    } : false,
    navigation: {
      nextEl: props.navigation ? ".swiper-button-next" : "",
      prevEl: props.navigation ? ".swiper-button-prev" : ""
    },
    wrapperClass: "swiper-wrapper ".concat(props.wrapperClass ? props.wrapperClass : "")
  };
  return props.data ? /*#__PURE__*/_jsx(ReactIdSwiper, _objectSpread(_objectSpread({}, params), {}, {
    children: props.data.map(function (slide, index) {
      return props.simple ? /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(Image, {
          src: getImageUrl(slide),
          layout: "fill",
          className: "bg-image",
          alt: "Cottage Centre vakantiehuizen en campers",
          loading: "eager"
        })
      }, slide) : /*#__PURE__*/_jsxs("div", {
        className: "h-auto px-2",
        children: [props.cards && /*#__PURE__*/_jsx("div", {
          className: "w-100 h-100 hover-animate",
          children: /*#__PURE__*/_jsx(CardRoom, {
            data: slide.properties,
            eager: true
          })
        }), props.propertyCards && /*#__PURE__*/_jsx("div", {
          className: "w-100 h-100 hover-animate",
          children: /*#__PURE__*/_jsx(CardProperty, {
            data: slide,
            eager: true
          })
        }), props.imgCards && /*#__PURE__*/_jsx(CardPoster, {
          data: slide,
          eager: true
        }), props.restaurantCards && /*#__PURE__*/_jsx("div", {
          className: "w-100 h-100 hover-animate",
          children: /*#__PURE__*/_jsx(CardRestaurant, {
            data: slide.properties,
            eager: true
          })
        }), props.placeCards && /*#__PURE__*/_jsx("div", {
          className: "w-100 h-100 hover-animate",
          children: /*#__PURE__*/_jsx(CardPlace, {
            data: slide,
            eager: true
          })
        })]
      }, index);
    })
  })) : "loading";
};

export default Swiper;